import { render, staticRenderFns } from "./LatestReplies.vue?vue&type=template&id=c75a6742&lang=pug&"
import script from "./LatestReplies.vue?vue&type=script&lang=js&"
export * from "./LatestReplies.vue?vue&type=script&lang=js&"
import style0 from "./LatestReplies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports